import React, { useState, useEffect } from "react";
import { Navbar } from "../../components/Navbar";
import MainCarousel from "../../components/main/MainCarousel";
import FamilySites from '../../components/main/FamilySites';
import BoardShortcut from '../../components/main/BoardShortcut';
import YouTubeSection from "../../components/main/YoutubeSection";
import FloatingDrawer from "../../components/main/FloatingDrawer";
import { Footer } from "../../components/Footer";
import styled from "styled-components";
import { useAuthApi } from "../../hooks/api/axiosInterceptor";
import { useNavigate } from "react-router-dom";
import CalendarReadPage from "../../components/CalendarRead";


const Wrapper = styled.div`
    height: 100%;
    width: 100%;
    overflow: hidden;

    @media all and (max-width: 1340px) {
        overflow-x: auto;
    }
`;

const Home = () => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const verifyAuthentication = async () => {
            try {
                // Check if token exists
                const token = localStorage.getItem("access_token");

                if (!token) {
                    // If no token
                }
                
                // Call protected endpoint to verify token
                const response = await useAuthApi.get("/auth/protected");
                
                if (response.data.status === "SUCCESS") {
                    // Authentication successful, set user data
                    setUser(response.data.data);
                    /*
                    sample response.data.data:
                    "data": {
                        "id": user['id'],
                        "user_id": user['user_id'],
                        "username": current_user,
                        "role": user['role']
                    }
                    */
                } else {
                    // Token exists but invalid
                    localStorage.removeItem("access_token");
                }
            } catch (error) {
                console.error("Authentication verification failed:", error);
                // Handle different error scenarios
                if (error.response && error.response.status === 401) {
                    // Unauthorized, clear token
                    localStorage.removeItem("access_token");
                }
                // For other errors, stay on page but set user to null
                setUser(null);
            } finally {
                setLoading(false);
            }
        };

        verifyAuthentication();
    }, [navigate]);

    if (loading) {
        return <div>Loading...</div>; 
    }

    return (
        <Wrapper>
            {/* <Navbar mode="home" /> */}

            <Navbar  />
            <FloatingDrawer />
            <MainCarousel />
            <FamilySites />
            <BoardShortcut />
            {/* <YouTubeSection /> */}
            <Footer />
        </Wrapper>
    );
};

export default Home;
